import ShapeProps from './ShapeProps'

export default {
    name: 'kendo-diagram-shape',
    render () {
        return null
    },
    mixins: [ShapeProps]
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagramShape/index.js